import App from './App.svelte';

const product = new URLSearchParams(window.location.search).get('product');

const app = new App({
    target: document.getElementById('svelte-root'),
    props: { product }
});

export default app;
